export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11117.a79c2856.jpg";